module.exports = __webpack_public_path__ + "static/images/storefront.3a45d67eb62f3ab7933347a0fef61853.svg";